export const language = {
  cn: {
    code: "zh",
    name: "Chinese",
  },
  cz: {
    code: "cs",
    name: "Czech",
  },
  nl: {
    code: "nl",
    name: "Dutch",
  },
  en: {
    code: "en",
    name: "English",
  },
  fr: {
    code: "fr",
    name: "French",
  },
  de: {
    code: "de",
    name: "German",
  },
  hu: {
    code: "hu",
    name: "Hungarian",
  },
  id: {
    code: "id",
    name: "Indonesian",
  },
  it: {
    code: "it",
    name: "Italian",
  },
  lt: {
    code: "lt",
    name: "Lithuanian",
  },
  pl: {
    code: "pl",
    name: "Polish",
  },
  ro: {
    code: "ro",
    name: "Romanian",
  },
  ru: {
    code: "ru",
    name: "Russian",
  },
  sk: {
    code: "sk",
    name: "Slovak",
  },
  sl: {
    code: "sl",
    name: "Slovenian",
  },
  es: {
    code: "es",
    name: "Spanish",
  },
  th: {
    code: "th",
    name: "Thai",
  },
  tr: {
    code: "tr",
    name: "Turkish",
  },
  ua: {
    code: "ua",
    name: "Ukrainian",
  },
};
